<template>
  <div class="d-flex flex-column align-center prepare-signature-warning">
    <app-material-icon
      name="warning"
      filled
      size="lg"
      color="grey-600"
      class="mb-5"
    />
    <h2 class="text-center mb-2">{{ warningTitle }}</h2>
    <p class="text-center">{{ warningSubtitle }}</p>
    <app-button
      v-if="warningButtonText"
      class="mt-4"
      type="outlined"
      variant="neutral"
      :href="linkHelpCenter"
      target="_blank"
    >
      {{ warningButtonText}}
    </app-button>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useTranslation } from '@/common/utils/translation'
import { SIGNATURE_DOCUMENT_ERROR } from '@/project/signing-checklist/constants'


const { t } = useTranslation({ keyPrefix: 'project.signing-checklist.prepare-signature.prepareSignatureWarning' })

const props = defineProps({
  fileErrorType: {
    type: String,
    default: null,
  },
})

const maxSignablePages = Number(import.meta.env.VUE_APP_MAX_SIGNABLE_PAGES)

const warningTitle = computed(() => {
  if (props.fileErrorType === SIGNATURE_DOCUMENT_ERROR.ERROR_OVER_PAGES) {
    return t(SIGNATURE_DOCUMENT_ERROR.ERROR_OVER_PAGES, { maxSignablePages }) 
  }
  return t(SIGNATURE_DOCUMENT_ERROR.ERROR_PREVIEW_GENERATION)
})

const warningSubtitle = computed(() => {
  if (props.fileErrorType === SIGNATURE_DOCUMENT_ERROR.ERROR_OVER_PAGES) {
    return t('toChangeFile')
  }
  return t('invalidFile')
})

const warningButtonText = computed(() => {
  if (props.fileErrorType === SIGNATURE_DOCUMENT_ERROR.ERROR_OVER_PAGES) {
    return null
  }
  return t('toHelpCenter')
})

const linkHelpCenter = computed(() => {
  return t('urlHelpCenter')
})

</script>

<style scoped lang="scss">
.prepare-signature-warning {
  max-width: 560px;
  padding: 0 40px;
}
</style>